import { Col, InputProps, Pagination, PaginationProps, Row, Table, TableProps } from 'antd';
import { FC, ReactNode, RefObject, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import InputSearch from '../InputSearch';
import { SvgPaginationNext } from '../svg/SvgPaginationNext';
import { SvgPaginationPrev } from '../svg/SvgPaginationPrev';
import './style.scss';

export interface TableWrapProps {
  isPagination?: boolean;
  loading: boolean;
  rightTopContent?: ReactNode;
  leftTopContent?: ReactNode;
  tableProps?: TableProps;
  middleContent?: ReactNode;
  inputProps?: InputProps;
  paginationProps?: PaginationProps;
  tableWrapperRef?: RefObject<HTMLDivElement>;
  onSearch?: (keyword: string) => void;
}

const TableWrap: FC<TableWrapProps> = (props) => {
  const {
    isPagination,
    loading,
    rightTopContent,
    leftTopContent,
    middleContent,
    tableProps,
    paginationProps,
    tableWrapperRef,
    onSearch,
    inputProps,
  } = props;

  const [keyword, setKeyword] = useState<string>('');

  return (
    <Row gutter={[0, 16]} className="custom_table">
      {(leftTopContent || onSearch || rightTopContent) && (
        <Col span={24} className="custom_table-top">
          <Row align="middle" justify="space-between">
            <Col>
              {leftTopContent && <Col>{leftTopContent}</Col>}
              {onSearch && (
                <Col>
                  <InputSearch
                    value={keyword}
                    onChange={(event) => setKeyword(event.target.value)}
                    onPressEnter={() => onSearch(keyword)}
                    onSearch={() => onSearch(keyword)}
                    {...inputProps}
                    width={inputProps?.width ? Number(inputProps?.width) : 330}
                  />
                </Col>
              )}
            </Col>
            {rightTopContent && <Col>{rightTopContent}</Col>}
          </Row>
        </Col>
      )}

      {middleContent && <Col span={24}>{middleContent}</Col>}

      <Col span={24} className="custom_table-middle" ref={tableWrapperRef}>
        <Table
          {...tableProps}
          loading={loading}
          bordered
          className={`custom_table-middle-table ${tableProps?.className || ''}`}
          pagination={false}
          rowKey={tableProps?.rowKey ? tableProps.rowKey : () => uuidv4()}
        />
      </Col>

      {isPagination && (
        <Col span={24} className="custom_table-bottom">
          <Pagination
            {...paginationProps}
            prevIcon={<SvgPaginationPrev />}
            nextIcon={<SvgPaginationNext />}
            showSizeChanger={false}
          />
        </Col>
      )}
    </Row>
  );
};

export default TableWrap;
